<template>
  <div>
    <paginated-data-table
      class="booklets-table"
      :query="queryFlyers"
      :query-variables="queryVariables"
      :headers="headers"
      :search="search"
      query-name="flyers"
      query-main-property-name="flyers"
      item-key="_id"
      default-table-sort-by="updated_at"
      :default-table-sort-desc="true"
      :custom-items-per-page="franchiseTable ? 5 : 10"
      :updateTable="updateTable"
      @update:page="updateTable = false"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td class="nowrap-row">
            <div class="d-flex align-center colorful-border" :style="{ borderColor: getStatusLabel(item.status).color }">
              <div class="py-0 px-4 d-flex align-center">
                <mf-icon fill :size="16" :color="getStatusLabel(item.status).color" :icon="'fiber_manual_record'" :class="''" />
                {{ getStatusLabel(item.status).text }}
              </div>
            </div>
          </td>
          <td class="nowrap-row">
            <v-tooltip v-model="showTooltipTitle[item._id]" top max-width="250" content-class="truncated-tooltip">
              <template v-slot:activator="{ on }">
                <a class="title" @click="link(item._id, item.status)"
                  ><span v-on="on">{{ getFormatedText(item.title) }}</span></a
                >
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </td>
          <td class="nowrap-row">
            <v-tooltip v-model="showTooltipDescription[item._id]" top max-width="250" content-class="truncated-tooltip">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ getFormatedText(item.description) }}</span>
              </template>
              <span>{{ item.description }}</span>
            </v-tooltip>
          </td>
          <td id="item-units" class="nowrap-row">
            <v-tooltip v-if="item.units.length > 1" v-model="showTooltipUnits[item._id]" top max-width="250" content-class="truncated-tooltip">
              <template v-slot:activator="{ on }">
                <span v-on="on"> {{ item.units.length }} Lojas </span>
              </template>
              <span>{{ getFormatedUnits(item.units) }}</span>
            </v-tooltip>
            <v-tooltip v-else-if="item.units && item.units[0]" v-model="showTooltipUnits[item._id]" top max-width="250" content-class="truncated-tooltip">
              <template v-slot:activator="{ on }">
                <span v-on="on"> {{ getFormatedText(item.units[0].name) }} </span>
              </template>
              <span>{{ getFormatedUnits(item.units) }}</span>
            </v-tooltip>
          </td>
          <td>{{ getPriorityText(item.priority) }}</td>
          <td v-if="item.initial_date && item.final_date">
            {{ DateTime.fromISO(item.initial_date.toString()).toFormat('dd/MM/yyyy HH:mm') }} -
            {{ DateTime.fromISO(item.final_date.toString()).toFormat('dd/MM/yyyy HH:mm') }}
          </td>
          <td v-else>-</td>
          <td class="text-left">{{ DateTime.fromISO(item.updated_at).toFormat('dd/MM/yyyy') }}</td>
          <td class="text-right">
            <encartes-table-actions
              :flyer-id="item._id"
              :flyer-title="item.title"
              :status="item.status"
              :is-franchise="franchiseTable"
              @updateTable="updatingTable"
              @open-logs-modal="openLogsModal"
            />
          </td>
        </tr>
      </template>
    </paginated-data-table>
    <logs-modal v-model="logsDialog" tags="FLYERS" logTitle="encartes" :idItem="flyerId" />
  </div>
</template>

<script>
import truncate from 'lodash/truncate'
import LogsModal from '@/components/logs-modal/LogsModal.vue'
import { DateTime } from 'luxon'
import { QUERY_FLYERS } from '../../graphql'
import PaginatedDataTable from '@/components/PaginatedDataTable.vue'
import { getStatusLabel } from '@/config/helpers.js'

export default {
  components: {
    EncartesTableActions: () => import('@/modules/mobile/encartes/views/pages/EncartesTableActions.vue'),
    LogsModal,
    PaginatedDataTable,
  },
  props: {
    isFranchise: {
      type: Boolean,
      default: false,
    },
    franchiseTable: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: '',
    },
    statusToSearch: {
      type: Array,
      default: () => [],
    },
    units: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    dialog: false,
    logsDialog: false,
    flyerId: '',
    showTooltipDescription: {},
    showTooltipTitle: {},
    showTooltipUnits: {},
    flyers: [],
    DateTime: DateTime,
    maxRecords: 0,
    updateTable: false,
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Título',
          value: 'title',
        },
        {
          text: 'Descrição',
          value: 'description',
        },
        {
          text: 'Lojas',
          value: 'units',
        },
        {
          text: 'Prioridade',
          value: 'priority',
        },
        {
          text: 'Data de validade',
          value: 'final_date',
        },
        {
          text: 'Última atualização',
          value: 'updated_at',
        },
        {
          text: '',
          value: '',
          sortable: false,
        },
      ]
    },
    queryFlyers() {
      return QUERY_FLYERS
    },
    queryVariables() {
      if (this.franchiseTable) {
        return {
          status: this.statusToSearch,
          franchise: true,
          only_franchise: true,
          units: this.units.map((unit) => unit.id_erp),
        }
      }
      return {
        status: this.statusToSearch,
        franchise: false,
        only_franchise: false,
        units: this.isFranchise ? this.units.map((unit) => unit.id_erp) : null,
      }
    },
  },
  methods: {
    getStatusLabel,
    getFormatedUnits(units) {
      return units.map((unit) => unit.name).join(', ')
    },
    hasResults(status) {
      return Boolean(status === 'FINISHED' || status === 'PAUSED' || status === 'ACTIVE')
    },
    link(param, status) {
      let endpoint = 'visualizar'
      if (!this.franchiseTable) {
        endpoint = this.hasResults(status) ? 'resultados' : 'editar'
      }
      this.$router.push({ path: `/mobile/encartes/${endpoint}/${param}` }).catch((err) => {
        console.error(err)
      })
    },
    getFormatedText(text) {
      return truncate(text, {
        length: 24,
        separator: ' ',
      })
    },
    openLogsModal(id) {
      this.flyerId = id
      this.logsDialog = true
    },
    updatingTable() {
      this.updateTable = true
    },
    getPriorityText(priority) {
      const franchisePriorities = {
        3: 'Alta',
        2: 'Média',
        1: 'Baixa',
      }
      const franchiseePriorities = {
        6: 'Alta',
        5: 'Média',
        4: 'Baixa',
      }

      return this.isFranchise ? franchisePriorities[priority] : franchiseePriorities[priority]
    },
  },
}
</script>

<style lang="scss" scoped>
.colorful-border {
  border-left: 3px solid;
  height: 100%;
}

tr td:not(:first-child) .colorful-border {
  border: none;
}

::v-deep td:first-child {
  padding: 0 !important;
}

.booklets-table {
  td {
    color: $cinza-0;
    padding: 0 8px;
  }
  .title {
    color: $marca-0-l40;
    span {
      font-size: 14px !important;
      font-weight: 400;
    }
  }
  .pointer {
    cursor: pointer;
  }
}
</style>
